import axios from 'axios'

axios.defaults.timeout = 30000; //响应时间

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //配置请求头

// 添加请求拦截器添加token,暂时不用
// axios.interceptors.request.use((config) => {
//     config.headers.authorization = window.sessionStorage.getItem('token')
//     return config
// })

export default axios;